module.exports = __webpack_public_path__ + "img/schema_corset_1a.592a1da5.svg";